import { Component, Input, OnInit } from '@angular/core';
import { ClientService } from '@shared/services/client/client.service';
import { environment } from '@environments/environment';
import { ActiveAccountingPeriodDetails, OpenAccountingPeriodDetails } from '@shared/models/client/client.model';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'avenir-header-accounting-period',
    imports: [
        CommonModule
    ],
    templateUrl: './header-accounting-period.component.html',
    styleUrl: './header-accounting-period.component.scss'
})
export class HeaderAccountingPeriodComponent implements OnInit {
  @Input() testIdPrefix?: string;
  activePeriod: ActiveAccountingPeriodDetails = {} as ActiveAccountingPeriodDetails;
  openPeriod: {
    display: string;
    gracePeriodDate: string;
  } = {
    display: '',
    gracePeriodDate: '',
  };

  constructor (
    private clientService: ClientService
  ) { }

  ngOnInit(): void {
    this.clientService.getActiveAccountingPeriod(environment.CLIENT_ID).subscribe({
      next: (response) => {
        this.activePeriod = response;
        this.setOpenPeriodFromActiveOpenPeriods(this.activePeriod?.openAccountingPeriods);
      }
    })
  }

  private setOpenPeriodFromActiveOpenPeriods(
    openAccountingPeriods: OpenAccountingPeriodDetails[] | undefined
  ): void {
    const periods = openAccountingPeriods ?? [];
    const firstLegacyId = periods[0]?.legacyId;
    const secondLegacyId = periods[1]?.legacyId;

    if (firstLegacyId && secondLegacyId) {
      this.openPeriod.display = `${firstLegacyId} - ${secondLegacyId}`;
    }

    const gracePeriodSource = periods[1] ?? periods[0];
    this.openPeriod.gracePeriodDate = this.normalizeGraceEndDate(gracePeriodSource?.graceEndDate);
  }

  private normalizeGraceEndDate(value: string): string {
    if (!value) {
      return value;
    }

    const mmddyyyyMatch = value.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);

    if (mmddyyyyMatch) {
      const [, month, day, year] = mmddyyyyMatch;
      return `${year}-${month}-${day}`;
    }

    return value;
  }

}
